import { Component, Input, OnInit } from '@angular/core';
import { OverlayPanel } from 'primeng';
import { NgIf } from '@angular/common';

@Component({
  standalone: true,
  selector: 'overlay-panel-input',
  templateUrl: 'overlay-panel-input.component.html',
  imports: [NgIf],
  styleUrls: ['overlay-panel-input.component.scss'],
})
export class OverlayPanelInputComponent implements OnInit {
  @Input() public overlayPanelRef: OverlayPanel;

  public expanded: boolean = false;

  @Input() public text: string;

  @Input() public invalid: boolean;

  ngOnInit(): void {}

  toggleExpanded($event) {
    this.overlayPanelRef.toggle($event);
    this.expanded = this.overlayPanelRef.visible;
  }
}
